<script>
  export let pricing = "4,997";
  export let frequency = "/month";
  const tgeHeroMaxUrl = "https://www.launchpass.com/alfa-toro/tge-hero-max";
  const tgeMaxCheckoutUrl = "https://bit.ly/48387DK";
</script>

<div id="pricing" class="pricing">
  <div class="container">
    <div>
      <h1>One Subscription</h1>
    </div>
    <div class="pricing-inner-container">
      <div class="pricing-card tge-pro">
        <div class="pricing-card-top">
          <div class="pricing-card-header">TGE Hero</div>
          <div class="pricing-card-disclaimer">
            <div>$10,000+ Portfolio Suggested</div>
          </div>
        </div>
        <div class="pricing-number">
          <h2>$197</h2>
          <div class="pricing-frequency">{frequency}</div>
        </div>
        <div class="pricing-features">
          <div class="feature-container">
            <div class="feature-item">
              <div>Trade alerts & live voice</div>
              <div>Charts with trade ideas</div>
              <div>Community chatroom & support</div>
              <div>Pause or cancel anytime</div>
            </div>
          </div>
          <div class="pricing-included">Included</div>
        </div>
        <div class="pricing-action">
          <a target="_blank" class="button-filled" href={tgeHeroMaxUrl}>
            <div>
              <img src="/imgs/gextron-square.png" loading="lazy" />
            </div>
            <div>Join now!</div>
          </a>
        </div>
      </div>
      <div class="pricing-card">
        <div class="pricing-card-top">
          <div class="pricing-card-header">TGE Max</div>
          <div class="pricing-card-disclaimer">
            <div>$100,000+ Portfolio Suggested</div>
          </div>
        </div>
        <div class="pricing-number">
          <h2>${pricing}</h2>
          <div class="pricing-frequency">1-time payment</div>
        </div>
        <div class="pricing-features">
          <div class="feature-container">
            <div class="feature-item">
              <div>Everything from TGE Hero Max</div>
              <div>Full access to Gextron</div>
              <div>Unlimited 1-on-1 coaching calls</div>
            </div>
            <div class="feature-item">
              <div>Instant chat/call support</div>
            </div>
          </div>
          <div class="pricing-included">Included</div>
        </div>
        <div class="pricing-action">
          <a target="_blank" class="button-filled" href={tgeMaxCheckoutUrl}>
            <div>
              <img src="/tge-max-logo-square.png" loading="lazy" />
            </div>
            <div>Join today</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .pricing {
    padding: 0 5%;
    background-color: #ece6e8;
  }

  h1 {
    text-align: center;
    color: #000;
  }

  h2 {
    margin-bottom: 0;
  }

  .pricing-inner-container {
    display: flex;
    gap: 32px;
    flex-flow: column;
    margin-top: 60px;
  }

  .pricing-card {
    transform-origin: 10% 70%;
    color: #fff;
    background-color: #000;
    border: 1px solid #000;
    border-radius: 19px;
    flex: 1;
    padding: 40px;
    position: relative;
    overflow: hidden;
    box-shadow:
      0 20px 68px #00000040,
      0 1px 2px #0000004d,
      0 0 #000;
  }

  .pricing-card.tge-pro {
    background-color: #fff;
    color: #000;
  }

  .pricing-card-top {
    border-bottom: 1px dashed #fff;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 40px;
    display: flex;
  }

  .pricing-card.tge-pro .pricing-card-top {
    border-bottom-color: #000;
    color: #000;
  }

  .pricing-card-header {
    font-size: 30px;
    font-weight: 500;
    line-height: 100%;
  }

  .pricing-card-disclaimer {
    color: #acacac;
    border: 1px solid #acacac;
    border-radius: 4px;
    padding: 10px;
    font-size: 9px;
    line-height: 11px;
    text-transform: uppercase;
  }

  .pricing-card.tge-pro .pricing-card-disclaimer {
    border-color: #a09f9f;
    color: #a09f9f;
  }

  .pricing-number {
    padding-top: 40px;
    display: flex;
    gap: 7px;
    align-items: flex-end;
  }

  .pricing-features {
    background-image: linear-gradient(#282727, #1b1b1b);
    border-bottom: 1px solid #000;
    border-radius: 8px;
    margin-top: 32px;
    padding: 32px;
    position: relative;
    box-shadow:
      inset 0 1px 0.25px #ffffff29,
      inset 0 2px 1px #ffffff1c;
  }

  .pricing-card.tge-pro .pricing-features {
    border-bottom-color: transparent;
    background-image: none;
    border: 1px solid #000;
  }

  .feature-container {
    display: grid;
    gap: 10px;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
  }

  .pricing-card.tge-pro .feature-container {
    grid-template-columns: none;
  }

  .feature-item {
    flex-flow: column;
    display: flex;
    gap: 6px;
  }

  .pricing-included {
    color: #ffffff75;
    text-transform: uppercase;
    background-image: linear-gradient(#282727, #1b1b1b);
    border-bottom: 1px solid #000;
    border-radius: 4px;
    margin-top: 32px;
    padding: 8px;
    font-size: 9px;
    line-height: 11px;
    position: absolute;
    inset: -44px auto auto 32px;
    box-shadow:
      0 0 #0003,
      0 1px 2px #0000004d,
      inset 0 1px 0.25px #ffffff4d,
      inset 0 2px 1px #ffffff1c;
  }

  .pricing-action {
    gap: 24px;
    justify-content: flex-start;
    align-items: center;
    margin-top: 32px;
    display: flex;
  }

  .pricing-action a {
    gap: 16px;
    color: #fff;
    background-image: linear-gradient(#282727, #1b1b1b);
    border-bottom: 1px solid #000;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    margin-top: 0;
    padding: 8px 24px 8px 8px;
    font-size: 17px;
    text-decoration: none;
    display: inline-flex;
    position: relative;
    box-shadow:
      inset 0 1px 0.25px #ffffff29,
      inset 0 2px 1px #ffffff1c;
  }

  .pricing-action a > div:first-child {
    height: 56px;
    width: 56px;
    border-radius: 6px;
    overflow: hidden;
  }

  .pricing-action a img {
    width: 100%;
  }

  @media screen and (min-width: 725px) {
    .feature-container {
      grid-template-columns: 1fr 1fr;
      gap: 24px;
    }
  }

  @media screen and (min-width: 1024px) {
    .pricing-inner-container {
      padding-left: 40px;
      padding-right: 40px;
      flex-direction: initial;
    }

    .pricing-card.tge-pro {
      max-width: 40%;
    }
  }
</style>
